/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
import StatefulContainer from './stateful-select-container';
import Select from './select';
import defaultFilterOptions from './utils/default-filter-options';
import { TYPE, SIZE } from './constants';
import type { SelectProps, StatefulSelectProps } from './types';
export default function StatefulSelect({
  // @ts-ignore
  'aria-label': ariaLabel = null,
  // @ts-ignore
  'aria-describedby': ariaDescribedby = null,
  // @ts-ignore
  'aria-errormessage': ariaErrormessage = null,
  // @ts-ignore
  'aria-labelledby': ariaLabelledby = null,
  autoFocus = false,
  backspaceRemoves = true,
  clearable = true,
  closeOnSelect = true,
  creatable = false,
  deleteRemoves = true,
  disabled = false,
  error = false,
  positive = false,
  escapeClearsValue = true,
  // @ts-ignore
  filterOptions = defaultFilterOptions,
  filterOutSelected = true,
  // @ts-ignore
  getOptionLabel = null,
  // @ts-ignore
  getValueLabel = null,
  ignoreCase = true,
  isLoading = false,
  labelKey = 'label',
  maxDropdownHeight = '40vh',
  multi = false,
  onBlur = () => {},
  onBlurResetsInput = true,
  onChange = () => {},
  onFocus = () => {},
  onInputChange = () => {},
  onCloseResetsInput = true,
  onSelectResetsInput = true,
  // @ts-ignore
  onOpen = null,
  // @ts-ignore
  onClose = null,
  openOnClick = true,
  startOpen = false,
  // @ts-ignore
  options = [],
  overrides = {},
  required = false,
  searchable = true,
  size = SIZE.default,
  type = TYPE.select,
  // @ts-ignore
  value = [],
  valueKey = 'id',
  ...rest
}: StatefulSelectProps) {
  const propsToPass = {
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby,
    'aria-errormessage': ariaErrormessage,
    'aria-labelledby': ariaLabelledby,
    autoFocus,
    backspaceRemoves,
    clearable,
    closeOnSelect,
    creatable,
    deleteRemoves,
    disabled,
    error,
    positive,
    escapeClearsValue,
    filterOptions,
    filterOutSelected,
    getOptionLabel,
    getValueLabel,
    ignoreCase,
    isLoading,
    labelKey,
    maxDropdownHeight,
    multi,
    onBlur,
    onBlurResetsInput,
    onChange,
    onFocus,
    onInputChange,
    onCloseResetsInput,
    onSelectResetsInput,
    onOpen,
    onClose,
    openOnClick,
    startOpen,
    options,
    overrides,
    required,
    searchable,
    size,
    type,
    value,
    valueKey,
    ...rest
  };
  return <StatefulContainer {...propsToPass}>
      {(childrenProps: SelectProps) => <Select {...childrenProps} />}
    </StatefulContainer>;
}